module.exports = __webpack_public_path__ + "static/media/MHH.d7c36e8e.png";